import React from 'react';
import './style.css';
import Slider from 'react-slick';
import { Images } from '../../Atoms';
// import globeBlack from "../../Assets/home/grid-globe-icon-one.svg";
import globeGreen from '../../Assets/icon/green-globe-transparent.svg';

export default function Sliders({ data, classname, imgClassName, dot }) {
  var settings = {
    dots: dot ? false : true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
  };

  return (
    <div className="lg:pb-5 relative h-full">
      <Slider {...settings} className={`${classname} overflow-hidden`}>
        {data.map((item, index) => {
          return (
            <div className="relative w-[100%] " key={index}>
              <Images
                src={item.src}
                key={index}
                imgClassname={imgClassName ? imgClassName : ''}
                alt="mockups"
              />

              <div className="relative lg:containers mx-auto">
                {item.para && (
                  <div className="md:max-w-sm w-full md:absolute z-10 bottom-[20px] left-[20px] md:rounded-xl overflow-hidden">
                    <div
                      className="bg-gradient flex-center font-bold font-gilroy px-10 py-8"
                      style={{
                        background: `${item.clr ? item.clr : 'bg-green'}`,
                      }}
                    >
                      <Images
                        src={globeGreen}
                        className="w-10 rounded-full text-green"
                        alt="slider mockups"
                      />
                      <h4 className="py-3 card-title">{item.head}</h4>
                      <span className=" font-poppins font-medium lg:text-lg text-center max-w-[250px] pb-4 ">
                        {item.para}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
